import almparamterrbireport from "./almparamterrbireport";
import ctinf from "./ctinf";
import rbirports from "./rbirports";
export default {
    almparamterrbireport,
    ctinf,
    rbirports
}